// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>15</span>&nbsp;&nbsp;Turn your gaze from me, that I may be glad again,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;before I go my way and am no more.<br> </p> </div></div>";
// Exports
module.exports = code;